import React from 'react'
import { Media } from 'react-breakpoints'
import ContentLoader from 'react-content-loader'

import { useStyles } from './PlaceholderLoader.style'

const PlaceholderLoader = () => {
  const classes = useStyles()
  const bgColor = '#ffffff'
  const fgColor = '#eeeeee'

  return (
    <Media>
      {({ breakpoints, currentBreakpoint }) =>
        breakpoints[currentBreakpoint] < breakpoints.md ? (
          <ContentLoader
            title='Cargando...'
            className={classes.containerHorizontal}
            backgroundColor={bgColor}
            foregroundColor={fgColor}>
            <rect x='10vw' y='30' rx='10' ry='10' width='75vw' height={18} />
            <rect x='30vw' y='90' rx='10' ry='10' width='40vw' height={18} />

            <rect x='23vw' y='130' rx='10' ry='10' width='200' height={37} />
            <rect x='23vw' y='190' rx='10' ry='10' width='200' height={37} />
            <rect x='23vw' y='250' rx='10' ry='10' width='200' height={37} />

            <rect x='5vw' y='300' rx='10' ry='10' width='90vw' height={127} />

            <rect x='5vw' y='457' rx='10' ry='10' width='90vw' height={40} />

            <rect x='5vw' y='520' rx='10' ry='10' width='90vw' height={250} />
            <rect x='5vw' y='790' rx='10' ry='10' width='90vw' height={250} />
            <rect x='5vw' y='1060' rx='10' ry='10' width='90vw' height={250} />
          </ContentLoader>
        ) : (
          <ContentLoader
            title='Cargando...'
            className={classes.containerHorizontal}
            backgroundColor={bgColor}
            foregroundColor={fgColor}>
            <rect x='35vw' y='50' rx='10' ry='10' width='30vw' height={18} />
            <rect x='43vw' y='150' rx='10' ry='10' width='15vw' height={18} />

            <rect x='30%' y='190' rx='10' ry='10' width='200' height={37} />
            <rect x='45%' y='190' rx='10' ry='10' width='200' height={37} />
            <rect x='60%' y='190' rx='10' ry='10' width='200' height={37} />

            <rect x='10%' y='260' rx='10' ry='10' width='384' height={48} />
            <rect x='37%' y='270' rx='10' ry='10' width='50vw' height={25} />

            <rect x='10%' y='350' rx='10' ry='10' width='77vw' height={25} />
            <rect x='10%' y='390' rx='10' ry='10' width='77vw' height={400} />

            <rect x='42%' y='830' rx='10' ry='10' width='13vw' height={35} />
          </ContentLoader>
        )
      }
    </Media>
  )
}

export default PlaceholderLoader
